import React from 'react';
import { CardFull } from '../../widgets/Cards';
import { connect } from 'react-redux';
import { fetchObservations } from '../../../actions';
import VitalSign from './Examination/VitalSign';
import BMI from './Examination/BMI';
import Peakflow from './Examination/Peakflow';
import CVRisk from './Examination/CVRisk';
class Measurement extends React.Component {

    componentDidMount() {
        this.props.fetchObservations(this.props.id); 
    }

    render() {
        return (
            <CardFull title='Examinations'>
                    <VitalSign />
                    <BMI />
                    <Peakflow />
                    <CVRisk />
            </CardFull>
        )
    }



}

const mapStateToProps = (state) => {
    return { 
        observations : Object.values(state.observations)
    }
}

export default connect(mapStateToProps, {fetchObservations})(Measurement);



